import { render, staticRenderFns } from "./ServiceCalls.vue?vue&type=template&id=4d82aa0b&scoped=true"
import script from "./ServiceCalls.vue?vue&type=script&lang=js"
export * from "./ServiceCalls.vue?vue&type=script&lang=js"
import style0 from "./ServiceCalls.vue?vue&type=style&index=0&id=4d82aa0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d82aa0b",
  null
  
)

export default component.exports